import { IGetGroupInvitationsParams, IGroupInvitation } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

export const {
  endpoints: { fetchTeamInvitations },
  useFetchTeamInvitationsQuery,
  useLazyFetchTeamInvitationsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchTeamInvitations: build.query<
      IGroupInvitation[],
      IGetGroupInvitationsParams | void
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const service = MultiService.getService();

          const data = await service
            .getAccountingGateway()
            .getGroupsInvitations(params ?? undefined);

          return { data };
        },
      }),
      providesTags: [RequestType.TeamInvitations],
    }),
  }),
});

export const {
  selectDataWithFallbackCachedByParams: selectTeamInvitations,
  selectLoadingCachedByParams: selectTeamInvitationsLoading,
  selectStateCachedByParams: selectTeamInvitationsState,
} = createQuerySelectors({
  endpoint: fetchTeamInvitations,
  fallback: [],
});
